var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkModePeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18932 15.0532C8.44643 12.8244 10.4988 10.2533 12.6806 9.38092C14.8623 8.50853 16.6076 8.50849 18.7881 9.38117C20.9686 10.2538 22.8654 13.8819 22.2796 15.0531C21.6938 16.2244 9.6256 16.362 9.18932 15.0532Z",
    fill: "#E9E9E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4386 9.38083C8.29068 8.5361 6.11318 8.51738 3.95488 9.38039C1.77312 10.2528 -0.279284 12.8239 0.463609 15.0526C0.722556 15.8295 4.97707 15.8635 8.59845 15.7075C8.25308 14.9747 8.16214 14.3893 8.16214 13.5255C8.16214 11.8751 9.31344 10.4173 10.4386 9.38083Z",
    fill: "#E9E9E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.779 3.92677C10.779 6.09547 9.02091 7.85355 6.85222 7.85355C4.68352 7.85355 2.92544 6.09547 2.92544 3.92677C2.92544 1.75808 4.68352 0 6.85222 0C9.02091 0 10.779 1.75808 10.779 3.92677Z",
    fill: "#E9E9E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5067 3.92677C19.5067 6.09547 17.7486 7.85355 15.5799 7.85355C13.4112 7.85355 11.6531 6.09547 11.6531 3.92677C11.6531 1.75808 13.4112 0 15.5799 0C17.7486 0 19.5067 1.75808 19.5067 3.92677Z",
    fill: "#E9E9E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModePeopleIcon);
export default __webpack_public_path__ + "static/media/DarkModePeopleIcon.175ecb95faf10214e673fabcf5ed0f6b.svg";
export { ForwardRef as ReactComponent };